import { UniversalCarType } from '../car-types/universal.car.type';
import { TimingObject } from '../common/timing.object';

export class RimRequest {
  Diameters: number[];
  CarType: UniversalCarType;
  Timing: TimingObject;
}
